













import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { ERROR } from '@/main/store/actionTypes';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { apiProvider } from '../api';
import { DMS_MODULE, TAB_NAMES } from '../constants';
import { store } from '../store/edit';

export default PageModeMixin.extend({
	name: 'CertSpecOprav',
	props: {
		storeUri: { type: String, required: true },
	},
	data() {
		return {
			multipleSelection: [],
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		...mapActionsDvm(store.actions),
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		async applyChanges() {
			const idColumnIndex = this.SpecialistaNehodyTable!.cellNames!.idColumn;
			const checkboxColumnIndex = this.SpecialistaNehodyTable!.cellNames!.CHECKBOX;
			const selectedValues = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex], s.cells[checkboxColumnIndex]]);
			try {
				this.startLoading(`${TAB_NAMES.CERT_SPEC_OPRAV}Table`);
				const promises = selectedValues.map((value: any[]) => apiProvider.updateCertSpecOpravRow({ id: value[0], checkbox: !value[1] }));
				await Promise.all(promises);
				this.multipleSelection = [];
				await this.updateTable();
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
			} finally {
				this.endLoading(`${TAB_NAMES.CERT_SPEC_OPRAV}Table`);
			}
		},
		async updateTable(): Promise<void> {
			await this.getProvozovnaTableSchemaAndRows(TAB_NAMES.CERT_SPEC_OPRAV);
		},
	},
});
